import { useImperativeHandle, useRef } from "react";
import { ContextMenu } from "@/appComponents/Blocks/Composites/ContextMenu/ContextMenu";
import { GetWSMgr, ReRenderCanvas } from "@/Utils/StateLib";
import { Globals } from "@coreapp/CoreApp/Globals";
import { appstr } from "@coreapp/utils/appstr";

export const CanvasContextMenu = props => {
  const openCtrlRef = useRef(null);
  const readOnly =
    Globals._accountInfo.ReadOnlyMode() || Globals._uiConfig.InBackgroundEditorMode();

  useImperativeHandle(props.openCtrlRef, () => openCtrlRef.current);

  const handleClickCommand = cmd => () => {
    openCtrlRef.current?.setOpen(false);
    const wsMgr = GetWSMgr();
    if (!wsMgr) {
      return;
    }
    const cp = wsMgr.fCanvasPanel;
    const chartBox = cp.GetFirstSelectedBox(false);
    const aCmd = wsMgr.AssembleCommand(chartBox, cp, `CanvasRightClick_${cmd}`);
    aCmd["newvalue"] = cmd;
    wsMgr.HandleRightClickCmd("CanvasRightClick", aCmd);
    ReRenderCanvas();
  };

  const GetReadOnlyModeOptions = () => {
    return [
      {
        label: appstr("Select"),
        dataTestId: "ctx-menu-canvas-select",
        value: "Select",
        icon: "arrow-pointer",
        clickHandler: handleClickCommand("selecttool")
      },
      {
        label: appstr("Pan"),
        dataTestId: "ctx-menu-canvas-pan",
        value: "Pan",
        icon: "hand-pointer",
        clickHandler: handleClickCommand("pantool")
      }
    ];
  };

  const GetEditModeOptions = () => {
    const w = GetWSMgr();
    return [
      {
        label: appstr("Select"),
        dataTestId: "ctx-menu-canvas-select",
        value: "Select",
        icon: "arrow-pointer",
        clickHandler: handleClickCommand("selecttool")
      },
      {
        label: appstr("Pan"),
        dataTestId: "ctx-menu-canvas-pan",
        value: "Pan",
        icon: "hand-pointer",
        clickHandler: handleClickCommand("pantool")
      },
      {
        label: appstr("moveobj"),
        dataTestId: "ctx-menu-canvas-move-chart",
        value: "Move Chart",
        icon: "arrows-up-down-left-right",
        clickHandler: handleClickCommand("moveobj")
      },
      {
        label: appstr("movebox"),
        dataTestId: "ctx-menu-canvas-move-box",
        value: "Move Box",
        divider: true,
        clickHandler: handleClickCommand("moveboxtool")
      },
      {
        label: appstr("Paste"),
        dataTestId: "ctx-menu-canvas-paste",
        value: "Paste",
        icon: "clipboard",
        disabled: !w?.CanPaste(),
        divider: true,
        clickHandler: handleClickCommand("paste")
      },
      {
        label: appstr("addsub"),
        dataTestId: "ctx-menu-canvas-add-sub",
        value: "Add subordinate",
        icon: "user-plus",
        divider: true,
        clickHandler: handleClickCommand("addsubtool")
      },
      {
        label: appstr("addassist"),
        dataTestId: "ctx-menu-canvas-add-assist",
        value: "Add assistant",
        icon: "user-group",
        clickHandler: handleClickCommand("addassist")
      }
    ];
  };

  return (
    <ContextMenu
      floatingCtrlRef={props.floatingCtrlRef}
      openCtrlRef={openCtrlRef}
      options={readOnly ? GetReadOnlyModeOptions() : GetEditModeOptions()}
    />
  );
};
